(function () {
  // V_TIME_COL_02 — click-and-drag horizontal scroll for the worn-by cards list.
  function initDragScroll() {
    const lists = document.querySelectorAll(".c-worn-by-col-list");
    if (!lists.length) return;

    lists.forEach((list) => {
      let isDown = false;
      let hasMoved = false;
      let startX = 0;
      let startScrollLeft = 0;

      list.addEventListener("mousedown", (e) => {
        // Ignore right-clicks / middle-clicks
        if (e.button !== 0) return;
        isDown = true;
        hasMoved = false;
        startX = e.pageX;
        startScrollLeft = list.scrollLeft;
        list.classList.add("c-is-dragging");
      });

      list.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        const delta = e.pageX - startX;
        if (Math.abs(delta) > 3) hasMoved = true;
        e.preventDefault();
        list.scrollLeft = startScrollLeft - delta;
      });

      const release = () => {
        if (!isDown) return;
        isDown = false;
        list.classList.remove("c-is-dragging");
      };

      list.addEventListener("mouseup", release);
      list.addEventListener("mouseleave", release);

      // Suppress the click that fires after a drag, so dragging over a card
      // doesn't accidentally activate any click handlers on it.
      list.addEventListener(
        "click",
        (e) => {
          if (hasMoved) {
            e.preventDefault();
            e.stopPropagation();
            hasMoved = false;
          }
        },
        true
      );
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initDragScroll);
  } else {
    initDragScroll();
  }
})();

(function () {
  // V_TIME_CART_04 — Timeloop+ Subscription Upsell, Cart Hidden vs Shown (Var A).
  //
  // Control (no change): the UpCart drawer footer shows the "VIP Checkout+" subscription upsell
  // block (.timeloop-vip-drawer-container) with its benefits + "$9.99 every month", and the theme's
  // own scripts relabel the secondary checkout button to "Checkout without benefits".
  //
  // Var A: hide that upsell block entirely, relabel the remaining button to a plain "Checkout", and
  // make sure the Timeloop+ subscription variant is never in the cart. The body gets the
  // `c-V_TIME_CART_04-test` class from c-intelligems-tests.js. All values (label, variant id) come
  // from the c-v-time-cart-04 snippet's data-* attributes — JS only toggles, no static values here.
  //
  // The theme's interval forces `display:block !important` inline on the upsell block every 500ms, so
  // CSS alone can't hide it — we remove the node instead (the theme's querySelector then no-ops). The
  // theme's click handler on the checkout button (which strips the VIP variant before /checkout) lives
  // on the button element, so relabeling via innerHTML keeps it intact.
  var TEST_CLASS = "c-V_TIME_CART_04-test";
  var FOOTER_SELECTOR = ".upcart-footer, .styles_Footer__";
  var UPSELL_SELECTOR = ".timeloop-vip-drawer-container";
  var CHECKOUT_BTN_SELECTOR = ".upcart-checkout-button";

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function readConfig() {
    var el = document.querySelector(".c-v-time-cart-04-config");
    if (!el) return null;
    return {
      checkoutLabel: el.getAttribute("data-checkout-label") || "Checkout",
      vipVariantId: parseInt(el.getAttribute("data-vip-variant-id"), 10),
    };
  }

  // The UpCart drawer can render in the light DOM or inside #upCart's shadow root, so look in both.
  function getRoots() {
    var roots = [document];
    var host = document.querySelector("#upCart");
    if (host && host.shadowRoot) roots.push(host.shadowRoot);
    return roots;
  }

  // Replace the button label while preserving its lock icon. The flicker came from two scripts
  // fighting over every freshly re-rendered button: the theme's loop sets "Checkout without benefits"
  // while ours sets "Checkout". The theme guards its relabel with `dataset.vipProcessed`, so we set
  // that flag here first — the theme then skips this button entirely and never flips the text. We
  // mark it even when the text is already correct, so a just-rendered "Checkout" button is claimed
  // before the theme's next tick can touch it.
  function relabelCheckout(btn, label) {
    if (!btn) return;
    btn.dataset.vipProcessed = "true";
    if (btn.textContent.trim() === label) return;
    var icon = btn.querySelector(".upcartLockIcon, svg, img");
    btn.innerHTML = "";
    if (icon) btn.appendChild(icon);
    btn.appendChild(document.createTextNode(icon ? " " + label : label));
  }

  function applyVarA(cfg) {
    getRoots().forEach(function (root) {
      var footer = root.querySelector(FOOTER_SELECTOR);
      if (!footer) return;

      var upsell = footer.querySelector(UPSELL_SELECTOR);
      if (upsell) upsell.remove();

      relabelCheckout(footer.querySelector(CHECKOUT_BTN_SELECTOR), cfg.checkoutLabel);
    });
  }

  // Belt-and-suspenders: if a shopper landed in Var A with the subscription already in their cart
  // (e.g. switched variants mid-session), strip it so it is never shown or charged. Runs once.
  var cartCleaned = false;
  function removeVipFromCart(cfg) {
    if (cartCleaned || !cfg.vipVariantId) return;
    cartCleaned = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    fetch(root + "cart.js")
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var vipItem = cart.items.find(function (item) {
          return item.variant_id === cfg.vipVariantId;
        });
        if (!vipItem) return;
        return fetch(root + "cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: vipItem.key, quantity: 0 }),
        });
      })
      .catch(function (err) {
        console.error("V_TIME_CART_04 cart cleanup failed:", err);
      });
  }

  var started = false;
  function start() {
    if (started) return;
    if (!document.body.classList.contains(TEST_CLASS)) return;
    var cfg = readConfig();
    if (!cfg) return;
    started = true;

    removeVipFromCart(cfg);

    // The drawer is re-rendered by UpCart on open/update, and the theme keeps re-forcing the upsell
    // visible, so re-apply on an interval (matching the theme's own cadence).
    applyVarA(cfg);
    setInterval(function () {
      applyVarA(cfg);
    }, 300);

    // Re-apply the instant UpCart re-renders the drawer, not just on the next interval tick. The
    // observer callback (coalesced into one rAF per frame) runs before paint, so the fresh button is
    // claimed/relabelled before the theme can flip it — making the text uniform with no visible flash.
    if ("MutationObserver" in window) {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          applyVarA(cfg);
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  ready(start);
  window.addEventListener("ig:ready", function () {
    ready(start);
  });
})();

/* ==========================================================================
   V_TIME_PDP_11 | Seek Zipup Offer Restructure — Offer Picker (Var A)
   Reads the JSON config rendered by snippets/c-v-time-pdp-11.liquid. Toggles the two
   picker options and, on the matching button:
     • single → add the current zip-up variant, then sync applies the PRE-ORDER code
     • bundle → add the zip-up + matched (same-size) sweats, then sync applies the BUNDLE
       code (which already bakes in the pre-order amount, so the pre-order code is NEVER
       also applied — the pre-order discount is never double-counted)
   then opens the cart drawer. Only acts for Var A; Control is untouched.
   ========================================================================== */
(function () {
  var TEST_CLASS = "c-V_TIME_PDP_11-test";
  var PAGE_CLASS = "c-vtp11-page";

  function readConfig() {
    var el = document.querySelector("[data-c-vtp11-data]");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function optionValue(v, idx) {
    return idx ? v["option" + idx] : null;
  }

  function norm(s) {
    return s == null ? "" : String(s).trim().toLowerCase();
  }

  function findVariant(list, id) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === id) return list[i];
    }
    return null;
  }

  // Size value of a cart line item (from its options).
  function cartItemSize(item) {
    var opts = item.options_with_values || [];
    for (var i = 0; i < opts.length; i++) {
      if (String(opts[i].name || "").toLowerCase().indexOf("size") > -1) {
        return opts[i].value;
      }
    }
    return null;
  }

  // Is this product (colour) already in the cart at this size? Matches by product + size rather than
  // exact variant id, so it correctly detects "same colour + size already added" even when the variant
  // id differs (e.g. pre-order variants, or the form id not matching what was added).
  function cartHas(cart, productId, size) {
    return (cart.items || []).some(function (i) {
      if (i.product_id !== productId) return false;
      if (size == null) return true;
      var s = cartItemSize(i);
      return s == null ? true : norm(s) === norm(size);
    });
  }

  // The selected variant on the PDP — the theme keeps [name="id"] in sync even when disabled.
  function getCurrentVariantId(cfg) {
    var input =
      document.querySelector('product-form form [name="id"]') ||
      document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) {
      var id = parseInt(input.value, 10);
      if (id) return id;
    }
    var fallback =
      cfg.current.variants.filter(function (v) {
        return v.available;
      })[0] || cfg.current.variants[0];
    return fallback ? fallback.id : null;
  }

  function renderDrawer(html) {
    var drawer = document.querySelector("cart-drawer");
    if (!drawer || !html) return false;
    var doc = new DOMParser().parseFromString(html, "text/html");
    var newInner = doc.querySelector(".drawer__inner");
    var curInner = drawer.querySelector(".drawer__inner");
    if (newInner && curInner) curInner.innerHTML = newInner.innerHTML;
    drawer.classList.remove("is-empty");
    drawer.classList.add("animate", "active");
    return true;
  }

  async function openCartDrawer() {
    // Render the drawer from a `POST /cart/update.js` AND apply the wanted discount in the SAME mutation.
    // Because /cart/update.js with `discount` sets the codes and recomputes the cart synchronously, the
    // returned cart-drawer section is guaranteed to reflect the discount — no reliance on a prior
    // cvtp11SyncDiscount() call having stuck, which is what caused the intermittent "refresh to see the
    // discount". We only send `discount` when it's a NON-empty Var-A code set, so Control (and any shopper
    // who typed their own code) is never touched.
    var discount = "";
    if (window.cvtp11DiscountString) {
      try {
        discount = await window.cvtp11DiscountString();
      } catch (e) {}
    }
    try {
      var body = {
        attributes: {},
        sections: ["cart-drawer"],
        sections_url: window.location.pathname
      };
      if (discount) body.discount = discount;
      var res = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify(body)
      });
      var cart = await res.json();
      if (cart && cart.sections && renderDrawer(cart.sections["cart-drawer"])) return;
    } catch (e) {}
    // Fallback: mirror the theme's passive AJAX drawer-open flow (see the pre-order button in buy-buttons.liquid).
    try {
      var fb = await fetch("/?sections=cart-drawer", {
        headers: { "X-Requested-With": "XMLHttpRequest" }
      });
      var json = await fb.json();
      if (renderDrawer(json["cart-drawer"])) return;
    } catch (e2) {}
    // Final fallback for app-based / native drawers.
    document.dispatchEvent(new CustomEvent("cart:refresh"));
  }

  // Currently selected offer ("single" | "bundle"), read off the picker root.
  function selectedOffer() {
    var root = document.querySelector("[data-c-vtp11]");
    return root && root.getAttribute("data-c-vtp11-selected") === "bundle"
      ? "bundle"
      : "single";
  }
  function setOffer(offer) {
    var root = document.querySelector("[data-c-vtp11]");
    if (root) {
      root.setAttribute(
        "data-c-vtp11-selected",
        offer === "bundle" ? "bundle" : "single"
      );
    }
  }

  var busy = false;
  async function addSelection(cfg, offer, btn) {
    if (busy) return;
    busy = true;
    if (btn) btn.classList.add("c-vtp11--loading");
    try {
      var curId = getCurrentVariantId(cfg);
      var curVar = curId ? findVariant(cfg.current.variants, curId) : null;
      // Zip-up out of stock → do nothing (button is also disabled in the UI).
      if (curVar && curVar.available === false) return;

      var cart = await fetch("/cart.js", {
        headers: { "X-Requested-With": "XMLHttpRequest" }
      }).then(function (r) {
        return r.json();
      });

      // Add the zip-up (skip if the same colour + size is already in the cart).
      var size = selectedSize(cfg);
      var hoodieIn = cartHas(cart, cfg.current.productId, size);
      var items = [];
      if (curId && !hoodieIn) items.push({ id: curId, quantity: 1 });

      if (offer === "bundle") {
        // Matching sweats must be the SAME size and in stock — never substitute a different size.
        var pairedVar = pairedSizeVariant(cfg);
        if (!pairedVar || pairedVar.available === false) return;
        var sweatsIn = cartHas(cart, cfg.paired.productId, size);
        if (pairedVar.id && !sweatsIn) items.push({ id: pairedVar.id, quantity: 1 });
      }

      if (items.length) {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify({ items: items })
        });
      }

      // Apply the RIGHT code for the resulting cart (Var A only, so Control never receives it):
      // bundle code when the cart holds the pair, pre-order code when it's the lone zip-up. Removal /
      // switching is handled by cvtp11SyncDiscount + Shopify's conditional (Buy-X-Get-Y) discounts.
      if (window.cvtp11SyncDiscount) {
        await window.cvtp11SyncDiscount();
      }

      await openCartDrawer();
    } catch (e) {
      /* leave the page usable */
    } finally {
      if (btn) btn.classList.remove("c-vtp11--loading");
      busy = false;
    }
  }

  // Is the currently selected MAIN-product variant in stock (per the config)?
  function currentAvailable(cfg) {
    var id = getCurrentVariantId(cfg);
    var v = id ? findVariant(cfg.current.variants, id) : null;
    return v ? !!v.available : true;
  }

  // Main product sold out? Trust the theme's own ATC button first (it already renders SOLD OUT /
  // sold-out / unavailable states correctly), then fall back to the variant availability flag.
  function mainSoldOut(cfg) {
    var atc =
      document.querySelector('#original-atc button[type="submit"]') ||
      document.querySelector("#original-atc button") ||
      document.querySelector('#original-atc [type="submit"]');
    if (atc && (atc.disabled || atc.getAttribute("aria-disabled") === "true")) {
      return true;
    }
    return !currentAvailable(cfg);
  }

  // The size currently selected on the main product.
  function selectedSize(cfg) {
    var id = getCurrentVariantId(cfg);
    var v = id ? findVariant(cfg.current.variants, id) : null;
    return v ? optionValue(v, cfg.current.sizeIndex) : null;
  }

  // The matching sweats variant for the SAME size (strict — no substituting a different size).
  function pairedSizeVariant(cfg) {
    var p = cfg.paired || {};
    var vs = p.variants || [];
    var size = selectedSize(cfg);
    if (size && p.sizeIndex) {
      return (
        vs.filter(function (v) {
          return norm(optionValue(v, p.sizeIndex)) === norm(size);
        })[0] || null
      );
    }
    return vs[0] || null;
  }

  // Is the matching sweats (same colour, same size) in stock? No matching size → treat as unavailable.
  function pairedAvailable(cfg) {
    var pv = pairedSizeVariant(cfg);
    return pv ? !!pv.available : false;
  }

  // Reflect stock on both buttons/options. Single needs the zip-up in stock; bundle needs the zip-up
  // AND the matching same-size sweats. If the sweats is unavailable, disable the bundle option and
  // fall back to single. Reads the config FRESH so it reflects the product shown after an AJAX swap.
  function updateBtnStates() {
    var cfg = readConfig();
    if (!cfg) return;
    // Option 1 uses the theme's own button (its own sold-out handling); we only manage the bundle CTA.
    var bundleOOS = mainSoldOut(cfg) || !pairedAvailable(cfg);

    var bundleBtn = document.querySelector('[data-c-vtp11-add="bundle"]');
    if (bundleBtn) {
      bundleBtn.disabled = bundleOOS;
      bundleBtn.classList.toggle("c-vtp11--oos", bundleOOS);
    }

    // Disable the bundle radio + option when the sweats can't be bundled, and force the single offer.
    var bundleRadio = document.querySelector(
      '[data-c-vtp11-radio][value="bundle"]'
    );
    var bundleOpt = bundleRadio && bundleRadio.closest(".c-vtp11__option");
    if (bundleRadio) {
      bundleRadio.disabled = bundleOOS;
      if (bundleOpt) bundleOpt.classList.toggle("c-vtp11--disabled", bundleOOS);
      if (bundleOOS && bundleRadio.checked) {
        var singleRadio = document.querySelector(
          '[data-c-vtp11-radio][value="single"]'
        );
        if (singleRadio) singleRadio.checked = true;
        setOffer("single");
      }
    }
  }

  // --- Mobile sticky ATC → mirror the bundle CTA when the bundle offer is selected ----------------------
  // The theme renders a sticky add-to-cart bar (#stickyAtcTrigger). ONLY on a target hoodie PDP in Var A
  // (TEST_CLASS + PAGE_CLASS), and ONLY while the BUNDLE offer is selected, relabel that sticky button to
  // the bundle CTA (with its dynamic price) and route its click to the picker's own bundle button
  // (.c-vtp11__btn--bundle), so it runs the exact same add-both-and-apply-discount flow. Single offer /
  // Control / non-target pages keep the theme's default sticky button and behaviour untouched.
  var STICKY_ID = "stickyAtcTrigger";
  var stickyOriginalHTML = null;

  function stickyIsBundleMode() {
    return (
      document.body.classList.contains(TEST_CLASS) &&
      document.body.classList.contains(PAGE_CLASS) &&
      selectedOffer() === "bundle"
    );
  }

  function bundleCtaLabel() {
    var lbl = document.querySelector(".c-vtp11__btn--bundle .c-vtp11__btn-label");
    return lbl ? lbl.textContent.trim() : "";
  }

  function updateStickyBundle() {
    var sticky = document.getElementById(STICKY_ID);
    if (!sticky) return;

    if (stickyIsBundleMode()) {
      // Remember the theme's original button content once, so single/Control can restore it verbatim.
      if (stickyOriginalHTML === null) stickyOriginalHTML = sticky.innerHTML;
      var label = bundleCtaLabel();
      if (label && sticky.textContent.trim() !== label) sticky.textContent = label;
      sticky.disabled = false;
      sticky.classList.add("c-vtp11-sticky-bundle");
    } else if (sticky.classList.contains("c-vtp11-sticky-bundle")) {
      // Leaving bundle mode → put the theme's default button back exactly as it was.
      if (stickyOriginalHTML !== null) {
        sticky.innerHTML = stickyOriginalHTML;
        stickyOriginalHTML = null;
      }
      sticky.classList.remove("c-vtp11-sticky-bundle");
    }
  }

  // Capture phase so we run BEFORE the theme's own click handler on the sticky button and can suppress it
  // (stopImmediatePropagation) when we're in bundle mode — then fire the picker's bundle button instead.
  function stickyClickCapture(e) {
    var sticky = e.target.closest && e.target.closest("#" + STICKY_ID);
    if (!sticky) return;
    if (!stickyIsBundleMode()) return; // single / Control → let the theme's default handler run
    var bundleBtn = document.querySelector('.c-vtp11__btn--bundle[data-c-vtp11-add="bundle"]');
    if (!bundleBtn || bundleBtn.disabled || bundleBtn.classList.contains("c-vtp11--oos")) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    bundleBtn.click();
  }

  function start() {
    if (!readConfig()) return; // not a target hoodie PDP

    // Mark the page so CSS can hide the theme ATC + the Bundle & Save block (rules also require the Var A class).
    document.body.classList.add(PAGE_CLASS);

    // Radio toggle → reflect the selected offer on the root (CSS swaps which button shows) and mirror it
    // onto the mobile sticky button.
    document.addEventListener("change", function (e) {
      var radio = e.target.closest && e.target.closest("[data-c-vtp11-radio]");
      if (!radio) return;
      setOffer(radio.value);
      updateStickyBundle();
    });

    // Route the sticky button to the bundle flow while the bundle offer is selected (capture phase).
    document.addEventListener("click", stickyClickCapture, true);

    document.addEventListener("click", function (e) {
      var btn = e.target.closest && e.target.closest("[data-c-vtp11-add]");
      if (!btn) return;
      if (!document.body.classList.contains(TEST_CLASS)) return; // Var A only
      if (btn.disabled || btn.classList.contains("c-vtp11--oos")) return; // OOS
      // Read the config FRESH — the theme AJAX-swaps the product info (and this script) on colour
      // change, so the captured config would otherwise be the previously viewed colour.
      var cfg = readConfig();
      if (!cfg) return;
      var offer = btn.getAttribute("data-c-vtp11-add") || selectedOffer();
      e.preventDefault();
      addSelection(cfg, offer, btn);
    });

    // Reflect stock state now and whenever the variant/colour changes or the theme re-renders the
    // product info. updateBtnStates() re-reads the config each time. Observe a broad, stable root.
    updateBtnStates();
    updateStickyBundle();
    var watchEl =
      document.querySelector("product-rerender") ||
      document.querySelector(".product") ||
      document.body;
    if (watchEl && "MutationObserver" in window) {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          updateBtnStates();
          updateStickyBundle();
        });
      }).observe(watchEl, { subtree: true, childList: true, attributes: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

/* ==========================================================================
   V_TIME_PDP_11 | Discount sync + sweats-page removal (Var A)
   Keeps the cart's discount set in step with its contents by SETTING the exact codes via
   /cart/update.js — codes are actively ADDED and REMOVED, with no reliance on Shopify auto-dropping:
     • hoodie + sweats (both from the configured lists) → pre-order code + bundle code (FBT15) stacked
     • hoodie OR sweats alone                           → pre-order code only (FBT15 removed)
     • neither                                          → no code (all cleared)
   The two codes must be set to COMBINE WITH each other in Shopify Admin so they can stack while the pair
   is present. Also hides the ATC + "Bundle & Save" block on a target SWEATS PDP (the 15% bundle is
   exclusive to the hoodie entry point). Exposes window.cvtp11SyncDiscount() so other flows can reuse it.

   Bundle button (.c-vtp11__btn--bundle): adds the configured sweats variant to cart, then syncs the
   discount. Handles: double-click / double-submit, missing config, missing variant id, network
   failure, button injected after DOMContentLoaded, multiple buttons on page, and Control bucket
   (button still adds to cart, but never triggers a discount).
   ========================================================================== */
(function () {
  var TEST_CLASS = "c-V_TIME_PDP_11-test";
  var SWEATS_CLASS = "c-vtp11-sweats-page";
  var LOADING_CLASS = "c-vtp11__btn--loading";
  var DISABLED_ATTR = "data-vtp11-busy";
  var LAST = "cvtp11_last_code"; // last code we applied, so we only re-hit /discount on a change
  var SYNC_RETRY_MS = 1500;

  // ---------- config ----------
  function readConfig() {
    var el = document.querySelector("[data-c-vtp11-discount]");
    if (!el) return null;
    try {
      var cfg = JSON.parse(el.textContent);
      // Defensive defaults so a partially-authored config doesn't throw downstream.
      cfg.hoodieIds = Array.isArray(cfg.hoodieIds) ? cfg.hoodieIds : [];
      cfg.sweatsIds = Array.isArray(cfg.sweatsIds) ? cfg.sweatsIds : [];
      cfg.bundleCode = cfg.bundleCode || "";
      cfg.preorderCode = cfg.preorderCode || "";
      return cfg;
    } catch (e) {
      return null;
    }
  }

  function isVarA() {
    return document.body.classList.contains(TEST_CLASS);
  }

  // ---------- last-applied tracking ----------
  function lastSet(v) {
    try {
      if (v) sessionStorage.setItem(LAST, v);
      else sessionStorage.removeItem(LAST);
    } catch (e) {}
  }
  function lastGet() {
    try {
      return sessionStorage.getItem(LAST) || "";
    } catch (e) {
      return "";
    }
  }

  // ---------- cart helpers ----------
  function getCart() {
    return fetch("/cart.js", {
      headers: { "X-Requested-With": "XMLHttpRequest" }
    }).then(function (r) {
      if (!r.ok) throw new Error("cart.js " + r.status);
      return r.json();
    });
  }

  // Which code(s) should be active for this cart? Returns the codes comma-joined (RAW — this feeds the
  // /cart/update.js `discount` field, a JSON value, so no URL-encoding) — "" = none. The bundle STACKS
  // both discounts: the pre-order code (flat $ off each pre-order unit) PLUS the bundle code (FBT15,
  // e.g. 15% off the sweats) on top. Shopify only stacks these if the two discounts are set to "combine
  // with" each other in Admin.
  function codeForCart(cfg, cart) {
    var items = cart.items || [];
    var hasHoodie = items.some(function (i) {
      return cfg.hoodieIds.indexOf(i.product_id) > -1;
    });
    var hasSweats = items.some(function (i) {
      return cfg.sweatsIds.indexOf(i.product_id) > -1;
    });

    var codes = [];
    // Pre-order applies to any lone pre-order item AND stays applied inside the bundle.
    if (hasHoodie || hasSweats) {
      if (cfg.preorderCode) codes.push(cfg.preorderCode);
    }
    // Bundle discount (FBT15) stacks ON TOP of pre-order ONLY when the cart holds the pair.
    if (hasHoodie && hasSweats) {
      if (cfg.bundleCode) codes.push(cfg.bundleCode);
    }

    return codes.join(",");
  }

  // ---------- discount sync ----------
  var syncRunning = false;
  var syncQueued = false;

  async function sync() {
    var cfg = readConfig();
    if (!cfg) return;

    // Control: never apply, and clear our local marker so we don't think a code is active.
    if (!isVarA()) {
      lastSet("");
      return;
    }

    // Coalesce overlapping calls (e.g. cart:change firing mid-sync) instead of racing fetches.
    if (syncRunning) {
      syncQueued = true;
      return;
    }
    syncRunning = true;

    var changed = false;
    try {
      var cart = await getCart();
      var want = codeForCart(cfg, cart); // "" = no code should be active

      // Only touch the cart when the desired set differs from what we last applied.
      if (want !== lastGet()) {
        // /cart/update.js with `discount` SETS the cart's full discount set (Shopify Cart AJAX API,
        // May 2025). Passing the exact codes we want both APPLIES new codes AND actively REMOVES any
        // no longer wanted: FBT15 drops the instant the bundle pair is broken (want shrinks to just the
        // pre-order code), and "" clears everything — no dependence on Shopify auto-dropping a
        // conditional discount. It's a cart mutation, so the totals recompute immediately.
        var res = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify({ discount: want })
        });
        if (res.ok) {
          lastSet(want);
          changed = true;
        } else {
          // Leave LAST as-is so the next sync() retries rather than silently giving up.
          scheduleRetry();
        }
      }
    } catch (e) {
      // Network hiccup — don't clear LAST (avoids re-firing a call we may have already succeeded on
      // right before the connection dropped), just retry shortly.
      scheduleRetry();
    } finally {
      syncRunning = false;
      if (syncQueued) {
        syncQueued = false;
        sync();
      } else if (changed) {
        // The discount set changed the cart totals — refresh the drawer/UI so it reflects the new (or
        // removed) discount. The re-triggered sync() no-ops because `want` now equals LAST.
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }
    }
  }

  var retryTimer = null;
  function scheduleRetry() {
    if (retryTimer) return;
    retryTimer = setTimeout(function () {
      retryTimer = null;
      sync();
    }, SYNC_RETRY_MS);
  }

  window.cvtp11SyncDiscount = sync;

  // Desired discount-code string for the CURRENT cart ("" = none / Control). Lets the drawer-open flow
  // apply the discount inside the SAME /cart/update.js mutation that renders the drawer, so the rendered
  // cart-drawer HTML always reflects it — independent of sync()'s last-applied guard. This is what removes
  // the intermittent "discount only shows after a manual refresh". Returns "" for Control (isVarA false)
  // so the caller knows NOT to touch discounts there (never clobber a shopper's own code).
  window.cvtp11DiscountString = async function () {
    var cfg = readConfig();
    if (!cfg || !isVarA()) return "";
    try {
      return codeForCart(cfg, await getCart());
    } catch (e) {
      return "";
    }
  };

  // ---------- bundle button ----------
  function readBundleVariantId(btn) {
    var raw = btn.getAttribute("data-vtp11-bundle-variant-id");
    var id = raw ? parseInt(raw, 10) : NaN;
    return isNaN(id) ? null : id;
  }

  function setBtnBusy(btn, busy) {
    btn.classList.toggle(LOADING_CLASS, busy);
    if (busy) {
      btn.setAttribute(DISABLED_ATTR, "1");
      btn.setAttribute("aria-disabled", "true");
    } else {
      btn.removeAttribute(DISABLED_ATTR);
      btn.removeAttribute("aria-disabled");
    }
  }

  function addToCart(variantId, qty) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(
          function (body) {
            throw new Error((body && body.description) || "cart/add.js " + r.status);
          },
          function () {
            throw new Error("cart/add.js " + r.status);
          }
        );
      }
      return r.json();
    });
  }

  function notifyCartChanged() {
    // Wake up this script's own sync() AND any theme cart-drawer listeners.
    document.dispatchEvent(new CustomEvent("cart:change"));
  }

  function handleBundleClick(evt) {
    var btn = evt.currentTarget;

    // Already mid-request — ignore double-click / double-tap instead of double-adding.
    if (btn.hasAttribute(DISABLED_ATTR)) {
      evt.preventDefault();
      return;
    }

    var variantId = readBundleVariantId(btn);

    // No variant configured on the button: nothing for us to add. Don't block whatever native
    // behavior the button might already have (e.g. a real <a href> or an existing handler from
    // theme JS) — just let it proceed, and still try a sync in case cart state already qualifies.
    if (!variantId) {
      sync();
      return;
    }

    evt.preventDefault();
    setBtnBusy(btn, true);

    addToCart(variantId, 1)
      .then(function () {
        notifyCartChanged();
        return sync();
      })
      .catch(function (err) {
        // Swallow to console only — don't leave the customer with a broken page if the theme's
        // own error UI isn't wired to this. Adjust to your theme's error surface if it has one.
        if (window.console && console.warn) {
          console.warn("[V_TIME_PDP_11] bundle add-to-cart failed:", err.message || err);
        }
      })
      .finally(function () {
        setBtnBusy(btn, false);
      });
  }

  function wireBundleButtons(root) {
    var scope = root || document;
    var btns = scope.querySelectorAll(".c-vtp11__btn--bundle");
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      // The offer-picker's bundle CTA carries data-c-vtp11-add and is fully owned by the picker flow
      // (addSelection: add → sync → open drawer). Binding here too would fire a SECOND, premature sync()
      // on click — against the pre-add cart — which then blocks addSelection's real sync (coalesced by the
      // syncRunning guard), so the bundle discount lands after the drawer recompute and never shows. Skip it.
      if (btn.hasAttribute("data-c-vtp11-add")) continue;
      if (btn.getAttribute("data-vtp11-wired") === "1") continue; // avoid double-binding
      btn.setAttribute("data-vtp11-wired", "1");
      btn.addEventListener("click", handleBundleClick);
    }
  }

  // Catch buttons injected later (e.g. by a cart drawer re-render, quick-view modal, infinite
  // scroll section, etc.) without re-wiring already-bound buttons.
  function observeForLateButtons() {
    if (!("MutationObserver" in window)) return;
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches(".c-vtp11__btn--bundle")) {
            wireBundleButtons(node.parentNode || document);
          } else if (node.querySelector) {
            wireBundleButtons(node);
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  // ---------- init ----------
  function init() {
    var cfg = readConfig();
    if (!cfg) return; // no config block on this page — nothing to do

    // Target SWEATS PDP: mark the page so CSS hides its ATC + "Bundle & Save" block. The class is
    // safe on Control because the CSS rule also requires the Var A body class.
    if (cfg.onSweatsPdp) document.body.classList.add(SWEATS_CLASS);

    // Bundle buttons are wired regardless of bucket — Control customers can still add the sweats
    // item to cart, they just never get a discount applied (sync() no-ops for them).
    wireBundleButtons(document);
    observeForLateButtons();

    if (!isVarA()) {
      lastSet("");
      return;
    }

    sync();
    document.addEventListener("cart:change", sync);
    document.addEventListener("cart:refresh", sync);
    document.addEventListener("cart-drawer:refreshed", sync);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

(function () {
  // V_TIME_CART_17 — Cart USP Trust Strip (Var A).
  //
  // Control (no change): the UpCart drawer shows its normal internal upsell block with nothing beneath it.
  //
  // Var A: insert a trust-USP strip (Easy Returns / 50,000+ orders shipped! / Secure Checkout) directly
  // BELOW the ".upcart-internal-upsell" block. Body gets `c-V_TIME_CART_17-test` from c-intelligems-tests.js
  // (Var A only). All copy + icons come from the c-v-time-cart-17 <template> (rendered by the snippet from
  // theme settings) — JS only clones the template and inserts it, so no static values live here.
  //
  // UpCart re-renders the drawer on open/update, so we re-insert on an interval + MutationObserver.
  // injectStrip() no-ops when our strip is already the upsell's next sibling, so re-running it is idempotent.
  var TEST_CLASS = "c-V_TIME_CART_17-test";
  var UPSELL_SELECTOR = ".upcart-internal-upsell";
  var STRIP_CLASS = "c-vtc17-strip";
  var TEMPLATE_ID = "c-vtc17-template";

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  // The UpCart drawer can render in the light DOM or inside #upCart's shadow root, so look in both.
  function getRoots() {
    var roots = [document];
    var host = document.querySelector("#upCart");
    if (host && host.shadowRoot) roots.push(host.shadowRoot);
    return roots;
  }

  // Clone the strip markup from the Liquid <template> (values already filled in by theme settings).
  function buildStrip() {
    var tpl = document.getElementById(TEMPLATE_ID);
    if (!tpl || !("content" in tpl)) return null;
    return tpl.content.cloneNode(true);
  }

  function injectStrip() {
    getRoots().forEach(function (root) {
      var upsells = root.querySelectorAll(UPSELL_SELECTOR);
      Array.prototype.forEach.call(upsells, function (upsell) {
        var next = upsell.nextElementSibling;
        if (next && next.classList && next.classList.contains(STRIP_CLASS)) return; // already inserted
        var frag = buildStrip();
        if (!frag || !upsell.parentNode) return;
        upsell.parentNode.insertBefore(frag, upsell.nextSibling);
      });
    });
  }

  var started = false;
  function start() {
    if (started) return;
    if (!document.body.classList.contains(TEST_CLASS)) return;
    if (!document.getElementById(TEMPLATE_ID)) return;
    started = true;

    injectStrip();
    setInterval(injectStrip, 300);

    // Re-insert the instant UpCart re-renders the drawer, not just on the next interval tick.
    if ("MutationObserver" in window) {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          injectStrip();
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  ready(start);
  window.addEventListener("ig:ready", function () {
    ready(start);
  });
})();
